export const normalizeNullValue = (value) => value ?? '';
